import React from "react";
import { Column, Columns } from "@origin-digital/ods-core";
import { HelperTextNodeProps } from "./types";

export const HelperTextNode = ({
  message,
  value,
  showCharacterCount = false,
  maxLength = 0,
  "data-id": dataId,
}: HelperTextNodeProps) => {
  return (
    <Columns>
      <Column data-id={`${dataId}-helper-content`}>{message}</Column>
      <Column data-id={`${dataId}-char-count`} width="content">
        {showCharacterCount
          ? `${(value as string)?.length ?? 0} / ${maxLength}`
          : ""}
      </Column>
    </Columns>
  );
};
